module.exports = __webpack_public_path__ + "7f975efdfbc3b72ae950634ebe6bc2c0.png";